import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Wordmark } from "@/components/brand/Logo";
import { LoadingScreen } from "@/components/shell/LoadingScreen";

export function AuthLayout() {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/app/dashboard" replace />;

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Left: form pane */}
      <div className="flex flex-col justify-between p-8 lg:p-12">
        <Wordmark />
        <div className="mx-auto w-full max-w-sm py-12">
          <Outlet />
        </div>
        <p className="text-xs text-muted-foreground">
  © {new Date().getFullYear()} MapleKey. Built in Canada. Reimagining property management.
</p>
      </div>

      {/* Right: brand pane */}
      <div className="hidden lg:flex relative overflow-hidden bg-sidebar text-sidebar-foreground">
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, hsl(var(--primary)) 0%, transparent 35%), radial-gradient(circle at 80% 70%, hsl(var(--accent)) 0%, transparent 35%)",
          }}
        />
        <div className="relative z-10 flex flex-col justify-end p-12">
          <blockquote className="space-y-4">
            <p className="text-2xl font-medium leading-tight tracking-tight">
              "Property management software hasn't been reimagined in fifteen
              years. MapleKey changes that, with AI in every workflow and
              compliance baked into every jurisdiction we touch."
            </p>
            <footer className="text-sm text-sidebar-foreground/70">
              MapleKey product principles
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
